
import ProductCardDefault from '@/components/ProductCard/ProductCardDefault.vue';

const sliderOptions = {
  0: {
    slidesPerView: 2.2,
    spaceBetween: 16,
  },
  1024: {
    slidesPerView: 3.2,
    spaceBetween: 16,
  },
};

export default {
  name: 'CartSimilarItems',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sliderOptions,
    };
  },
  components: {
    ProductCardDefault,
  },
};
